/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import Select from 'react-select'

import ReactDataTable from '@easygosanet/react-datatable'

import './assets/css/styles.css'

import {
  getPages,
  setProp,
  setDatos,
  setMessages,
  enviarMensaje,
} from 'redux/actions/fanpageMessage.actions'
import { withUtils } from 'utils'

const Datos = (props) => {
  useEffect(() => {
    if (!document.getElementById('facebook-jssdk')) {
      ;(function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) {
          return
        }
        js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/es_LA/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      })(document, 'script', 'facebook-jssdk')
    }

    window.fbAsyncInit = () => {
      window.FB.init({
        version: 'v9.0',
      })
    }

    props.getPages()
  }, [])

  const changePage = (option) => {
    props.setProp({ name: 'selectedPage', value: option })
  }

  const consultar = (e) => {
    e.preventDefault()
    props.setDatos(props.selectedPage.token)
  }

  const consultarMensajes = (conversationId) => {
    props.setMessages(conversationId, props.selectedPage.token)
  }

  const columnsConversations = [
    {
      name: 'ID',
      selector: 'id',
      sortable: true,
      center: true,
      cell: (row) => (
        <span
          style={{
            color: '#02025b',
            cursor: 'pointer',
          }}
          onClick={() => consultarMensajes(row.id)}
        >
          {row.id}
        </span>
      ),
    },
    {
      name: 'Usuario',
      selector: 'participants',
      sortable: true,
      center: true,
      cell: (row) => {
        return row.participants.data[0].name
      },
    },
    {
      name: 'Fecha actualización',
      selector: 'updated_time',
      sortable: true,
      center: true,
    },
    {
      name: 'Contestar',
      selector: 'link',
      sortable: true,
      center: true,
      cell: (row) => {
        return (
          <div>
            <textarea id={`msg-${row.id}`} rows='2'></textarea>
            <button
              type='button'
              onClick={() =>
                props.enviarMensaje(
                  `msg-${row.id}`,
                  row.participants.data[0].id,
                  props.selectedPage.token
                )
              }
            >
              Enviar
            </button>
          </div>
        )
      },
    },
  ]

  const columnsMessages = [
    {
      name: 'Fecha',
      selector: 'created_time',
      sortable: true,
      center: true,
    },
    {
      name: 'Mensaje',
      selector: 'message',
      sortable: true,
      center: true,
    },
    {
      name: 'Autor',
      selector: 'from',
      sortable: true,
      center: true,
      cell: (row) => {
        if (row.from) {
          return row.from.name
        }
        return ''
      },
    },
  ]

  return (
    <>
      <div>
        <Link to='/scan'>Regresar</Link>
      </div>
      <div>
        <label>Elegir fanpage:</label>
        <Select
          options={props.pages.map((page) => ({
            value: page.id,
            label: page.name,
            token: page.access_token,
          }))}
          onChange={changePage}
        />
      </div>
      <div hidden={!props.selectedPage}>
        <button type='button' onClick={consultar}>
          Consultar
        </button>
        <div className='Kanbang-content'>
          <div className='List-category'>
            <ReactDataTable
              title='Conversaciones'
              columns={columnsConversations}
              data={props.conversations}
              pagination
            />
          </div>
        </div>
        <div className='Kanbang-content'>
          <div className='List-category'>
            <ReactDataTable
              title={`Mensajes de ${props.conversationId}`}
              columns={columnsMessages}
              data={props.messages}
              pagination
            />
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  pages: state.fanpageMensajes.pages,
  selectedPage: state.fanpageMensajes.selectedPage,
  conversations: state.fanpageMensajes.conversations,
  conversationId: state.fanpageMensajes.conversationId,
  messages: state.fanpageMensajes.messages,
})

const mapDispatchToProps = {
  setProp,
  getPages,
  setDatos,
  setMessages,
  enviarMensaje,
}

export default connect(mapStateToProps, mapDispatchToProps)(withUtils(withRouter(Datos)))
